import { ColorOption } from "@/models/frontend-only/ColorOption";

export const AvailableFontFamilies = [
  {
    id: "open-sans",
    type: "Sans-Serif",
    fontFamilyName: "'Open Sans', 'Verdana', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
  },
  {
    id: "playfair",
    type: "Serif",
    fontFamilyName: "'Playfair', 'Garamond', serif",
    url: "https://fonts.googleapis.com/css2?family=Playfair:ital,opsz,wght@0,5..1200,400;0,5..1200,700;1,5..1200,400;1,5..1200,700&display=swap",
  },
  {
    id: "roboto-mono",
    type: "Monospace",
    fontFamilyName: "'Roboto Mono', 'Courier New', monospace",
    url: "https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,500;0,700;1,500;1,700&display=swap",
  },
  {
    id: "comic-neue",
    type: "Handwriting",
    fontFamilyName: "'Comic Neue', 'Brush Script MT', cursive",
    url: "https://fonts.googleapis.com/css2?family=Comic+Neue:ital,wght@0,400;0,700;1,400;1,700&display=swap",
  },
];

export const AvailableLyricVideoFontFamilies = [
  {
    id: "inter",
    type: "Sans-Serif",
    fontFamilyName: "'Inter', 'Verdana', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
  {
    id: "playfair",
    type: "Serif",
    fontFamilyName: "'Playfair', 'Garamond', serif",
    url: "https://fonts.googleapis.com/css2?family=Playfair:ital,opsz,wght@0,5..1200,400;0,5..1200,700;1,5..1200,400;1,5..1200,700&display=swap",
  },
  {
    id: "roboto-mono",
    type: "Monospace",
    fontFamilyName: "'Roboto Mono', 'Courier New', monospace",
    url: "https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,500;0,700;1,500;1,700&display=swap",
  },
  {
    id: "comic-neue",
    type: "Handwriting",
    fontFamilyName: "'Comic Neue', 'Brush Script MT', cursive",
    url: "https://fonts.googleapis.com/css2?family=Comic+Neue:ital,wght@0,400;0,700;1,400;1,700&display=swap",
  },
  {
    id: "oswald",
    type: "Narrow",
    fontFamilyName: "'Oswald', 'Arial Narrow', sans-serif",
    url: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Oswald:wght@200..700&display=swap",
  },
];

export const AvailableTextColors: ColorOption[] = [
  { name: "base100", light: "#000000", dark: "#fff" },
  {
    name: "blue",
    light: "#0733ff",
    dark: "#0733ff",
  },
  {
    name: "brown",
    light: "#ab7942",
    dark: "#ab7942",
  },

  {
    name: "cyan",
    light: "#04fdff",
    dark: "#04fdff",
  },

  {
    name: "green",
    light: "#01f900",
    dark: "#01f900",
  },
  {
    name: "magenta",
    light: "#ff40ff",
    dark: "#ff40ff",
  },

  {
    name: "orange",
    light: "#ff9302",
    dark: "#ff9302",
  },

  {
    name: "purple",
    light: "#942092",
    dark: "#942092",
  },

  {
    name: "red",
    light: "#ff2601",
    dark: "#ff2601",
  },
  {
    name: "yellow",
    light: "#fffc03",
    dark: "#fffc03",
  },
];

export const AvailableHighlightColors: ColorOption[] = [
  {
    name: "transparent",
    light: "rgba(0,0,0,0)",
    dark: "rgba(0,0,0,0)",
  },
  {
    name: "yellow",
    light: "#fffa00",
    dark: "#fffa00",
  },
  {
    name: "green",
    light: "#01f800",
    dark: "#01f800",
  },
  {
    name: "cyan",
    light: "#04fafd",
    dark: "#04fafd",
  },
  {
    name: "magenta",
    light: "#ff40fb",
    dark: "#ff40fb",
  },

  {
    name: "blue",
    light: "#0433ff",
    dark: "#0433ff",
  },
  {
    name: "red",
    light: "#ff2600",
    dark: "#ff2600",
  },
  {
    name: "gray-200",
    light: "#929292",
    dark: "#929292",
  },
  {
    name: "gray-100",
    light: "#cacaca",
    dark: "#cacaca",
  },
];
